// extracted by mini-css-extract-plugin
export default {"wrapper":"ZxM0nH6rnbarJRNDbbhR","container":"p7wkm5gyZwBUvE9_uDTV","list":"RUzp5RQE7zHbnLZar3GC"};